import { render, staticRenderFns } from "./backgroundAccount.vue?vue&type=template&id=a31bf960&scoped=true"
import script from "./backgroundAccount.vue?vue&type=script&lang=js"
export * from "./backgroundAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31bf960",
  null
  
)

export default component.exports